export const RECEIVE_SHIFTS = 'schedules/RECEIVE_SHIFTS';
export const SELECT_SHIFT = 'schedules/SELECT_SHIFT';
export const DESELECT_SHIFT = 'schedules/DESELECT_SHIFT';
export const SET_SHIFT_EXCHANGE_ID = 'schedules/SET_SHIFT_EXCHANGE_ID';

export const setShiftExchangeId = (shiftId, exchangeId) => ({
  type: SET_SHIFT_EXCHANGE_ID,
  shiftId,
  exchangeId,
});
